import { AsyncPipe, KeyValuePipe, NgClass, NgStyle } from "@angular/common";
import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatGridList, MatGridTile } from "@angular/material/grid-list";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { getFunctions, httpsCallable } from "firebase/functions";
import { BehaviorSubject, from, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { GameDatasService } from "src/app/pages/games/services/game-data.service";
import { SocialService } from "src/app/services/social.service";

@Component({
  selector: "app-mystery-box",
  templateUrl: "./mystery-box.component.html",
  styleUrls: ["./mystery-box.component.scss"],
  standalone: true,
  imports: [
    NgStyle,
    NgClass,
    MatGridList,
    MatGridTile,
    AsyncPipe,
    KeyValuePipe,
    TranslatePipe,
  ],
})
export class MysteryBoxComponent implements OnInit {
  panelOpenState = false;
  public mysteryBoxData$ = new BehaviorSubject<Data>(null);
  @Input() currentTab: number;
  public prizeListData$ = new BehaviorSubject<Data>(null);
  public prizeValues = [];
  public fadeIn: boolean;
  public fadeOut: boolean;
  public claimPrize: Data;
  public documentID: string;
  ctaType: string;
  public autoShow: boolean;
  public giftBoxType: string;
  public PrizeValue: string;
  public userId: string;
  constructor(
    private matDialogRef: MatDialogRef<MysteryBoxComponent>,
    private socialService: SocialService,
    private gameDatasService: GameDatasService,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private authService: AuthService,
    private translate: TranslateService

  ) {
    this.fadeIn = false;
    this.fadeOut = false;
    const lootBoxType = data?.lootBoxType;
    this.ctaType = data?.type;
    this.claimPrize = data?.prize;
    this.documentID = data?.docID;
    this.autoShow = data?.autoShow;
    this.giftBoxType = this.autoShow ? "mission" : "hero";
    this.ctaType === "locked" ? this.getAdLootBoxData(lootBoxType) : this.getClaimLootBoxData(lootBoxType);
    // This method has been used to get the converted currency credit value
    this.currencyConversion(data?.prize?.value);
    // This method has been used to translate the content
    this.translation()
  }

  async ngOnInit() {
    await this.authService.getUid("MysteryBoxComponent").then((uid) => {
      this.userId = uid;
    })
    const fadeInTimeout = 2000;
    const fadeOutTimeout = 4000;
    // This method is used to display the dialog box after 2 seconds
    setTimeout(() => {
      this.fadeIn = true;
    }, fadeInTimeout);
    // This method is used to display the dialog box after 4 seconds
    setTimeout(() => {
      this.fadeOut = true;
    }, fadeOutTimeout);
  }
  // This method is used to close the dialog
  close() {
    this.matDialogRef.close("isClaim");
    // This method is used to call the giftBoxReward method
    this.giftBoxReward();
    this.updateAutoShowStatus(this.documentID);
  }

  // This method has been used to get the mystery box data from the API

  getAdLootBoxData(lootBoxType: string) {
    this.socialService
      .getMysteryBoxData(lootBoxType)
      .pipe(
        catchError((err) => {
          // Handle the error before the subscribe
          return throwError(err);
        })
      )
      .subscribe((res: Data) => {
        try {
          const prizeList = res?.data?.prize_list; // This variable is used to store the prize list
          for (const key in prizeList) {
            this.prizeValues.push(prizeList[key].prize.value);
            if (prizeList[key].prize.type === "credit") {
              this.getCurrencyValue(prizeList, key);
            }
          }
          // This observable is used to observe the prize list data
          this.prizeListData$.next(prizeList);
          // This observable is used to observe the mystery box data
          this.mysteryBoxData$.next(res);
        } catch (err) {
          return throwError(err);
        }
      });
  }
  // Assuming you are in a class or function scope
  creditValue: string[] = [];
  // This method has been used to get the converted currency credit value
  getCurrencyValue(prizeList: Data, key: string) {
    // This method has been used to get the converted currency credit value
    this.gameDatasService
      .getDVCurrency(prizeList[key].prize.value)
      ?.then((res: string) => {
        try {
          this.creditValue.push(res);
          if (this.prizeValues.length >= 2) {
            this.prizeValues.splice(0, 2, this.creditValue[0], this.creditValue[1]);
          } else {
            console.error(
              "PrizeValues does not contain enough elements for splice operation."
            );
          }
        } catch (err) {
          return throwError(err);
        }
      });
  }
  // This method has been used to get the claim box data from the API
  getClaimLootBoxData(lootBoxType: string) {
    this.socialService
      .getClaimBoxData(lootBoxType)
      .pipe(
        catchError((err) => {
          // Handle the error before the subscribe
          return throwError(err);
        })
      )
      .subscribe((res: Data) => {
        try {
          const prizeList = res.data.prize_list;
          for (const key in prizeList) {
            this.prizeValues.push(prizeList[key].prize.value);
            if (prizeList[key].prize.type === "credit") {
              this.getCurrencyValue(prizeList, key);
            }
          }
          // This observable is used to observe the mystery box data
          this.mysteryBoxData$.next(res);
          this.prizeListData$.next(prizeList);
        } catch (err) {
          return throwError(err);
        }
      });
  }
  // This method has been used to call the gift box reward API
  public giftBoxReward() {
    const request = {
      giftbox_id: this.documentID,
      type: this.giftBoxType,
    };
    const functions = getFunctions();
    functions.region = AuthService.FIREBASE_REGION;
    // This method has been used to call API herogiftboxrewardv2
    const api = httpsCallable(functions, "herogiftboxrewardv2");
    return from(api(request));
  }
  // This method has been used to update the auto show status
  public updateAutoShowStatus(docID: string) {
    try {
      // This method has been used to update the auto show status as true
      this.socialService.updateAutoShownGiftBoxStatus(docID);
    } catch (err) {
      // Handle the error
      return err;
    }
  }

  // This method has been used to get the converted currency credit value
  currencyConversion(value) {
    if (typeof value === "string") {
      this.gameDatasService.getDVCurrency(value)?.then((res: string) => {
        try {
          this.PrizeValue = res;
          return res;
        } catch (err) {
          return throwError(err);
        }
      });
    } else {
      this.PrizeValue = value;
    }
  }
  // This Method has been used to add translation
  translation() {
    this.authService.selectedlanguage$?.subscribe(
      (language: string) => {
        if (language) {
          this.translate.use(language ? language : 'en');
        }
      },
      (err) => {
        return (err);
      }
    )
  }
}
